function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.994 3.486V13h-2V3.486L1.62 6.846.37 5.602 5.994 0l5.624 5.602-1.25 1.244z",
  fill: "#0B0E13",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxM3B4IiB2aWV3Qm94PSIwIDAgMTIgMTMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjMgKDUxMTY3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5hcnJvdy11cDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iSWNvbnMvQXJyb3cvVXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yLjAwMDAwMCwgLTEuMDAwMDAwKSIgZmlsbD0iIzBCMEUxMyI+CiAgICAgICAgICAgIDxnIGlkPSJhcnJvdy11cCI+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iQXJyb3ciIHBvaW50cz0iOC45OTQwMDYzOCA0LjQ4NTU2ODQ5IDguOTk0MDA2MzggMTQgNi45OTQwMDYzOCAxNCA2Ljk5NDAwNjM4IDQuNDg1NTY4NDkgMy42MTk3NzkxMSA3Ljg0NjMwNjg1IDIuMzY5OTk5ODkgNi42MDE1MjM3OCA3Ljk5NDAwNjM4IDEgMTMuNjE4MDEyOSA2LjYwMTUyMzc4IDEyLjM2ODIzMzcgNy44NDYzMDY4NSI+PC9wb2x5Z29uPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/images/icons/arrow-up.svg